__turbopack_context__.v({
  "container": "NarrowColumnContainer-module-scss-module__rthNzq__container",
  "title": "NarrowColumnContainer-module-scss-module__rthNzq__title",
});
